import React from "react";
import { Link } from "@/components/LocaleLink";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import PageHero from "@/components/PageHero";
import FinalCTA from "@/components/FinalCTA";
import { Reveal } from "@/components/Reveal";

const IMG = "https://images.unsplash.com/photo-1765366417046-f46361a7f26f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const Akut = () => {
  const { t } = useLang();
  const a = t.akut;

  return (
    <>
      <PageHero eyebrow={a.hero} title={a.heroLead} intro={a.intro} image={IMG} />

      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16 lg:py-24 space-y-16">
        {a.sections.map((sec, si) => (
          <div key={sec.title} data-testid={`akut-section-${si}`}>
            <Reveal>
              <h2 className="font-display text-3xl sm:text-4xl text-[#1A2E24] mb-4">{sec.title}</h2>
            </Reveal>
            <Reveal delay={0.05}>
              <p className="text-lg text-[#3B5245] leading-relaxed">{sec.text}</p>
            </Reveal>
            {sec.list && (
              <Reveal delay={0.1}>
                <div className="mt-6 grid sm:grid-cols-2 gap-3">
                  {sec.list.map((it) => (
                    <div key={it} className="flex items-start gap-3 rounded-xl bg-white border border-black/5 px-5 py-3.5">
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#C47C5D] shrink-0" aria-hidden="true" />
                      <span className="text-[#1A2E24] leading-snug">{it}</span>
                    </div>
                  ))}
                </div>
              </Reveal>
            )}
          </div>
        ))}

        {/* Boundary */}
        <Reveal>
          <div className="rounded-2xl border border-[#C47C5D]/40 bg-[#C47C5D]/10 p-6 sm:p-7 flex gap-4" data-testid="akut-boundary">
            <AlertTriangle className="h-5 w-5 text-[#C47C5D] shrink-0 mt-0.5" />
            <p className="text-[#1A2E24] leading-relaxed">{a.boundary}</p>
          </div>
        </Reveal>

        {/* CTA */}
        <Reveal>
          <Link
            to="/kontakt?kilde=akut-stoette&henvendelse=konkret-opgave"
            className="group inline-flex items-center gap-2 rounded-full bg-[#2D5A3F] text-white px-8 py-4 font-medium hover:bg-[#1A2E24] transition-colors duration-300"
            data-testid="akut-cta"
          >
            {a.cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>

      <FinalCTA />
    </>
  );
};

export default Akut;
